import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import { LuShieldMinus } from 'react-icons/lu'
import { showSuccess } from '@/lib/alert'
import { useDemoteAgendaMember } from '@/hooks/agendas/useDemoteAgendaMember'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import type { AgendaMember } from '@/services/agendas'

type Props = {
  agendaId: string
  member: AgendaMember
}

const DemoteMemberButton = ({ agendaId, member }: Props) => {
  const [open, setOpen] = useState(false)
  const { mutate: demote, isPending } = useDemoteAgendaMember(agendaId)

  const handleConfirm = () => {
    demote(member.user.id, {
      onSuccess: () => {
        showSuccess('Membro rebaixado com sucesso!')
        setOpen(false)
      },
    })
  }

  return (
    <>
      <Button colorPalette="gray" variant="outline" size="xs" onClick={() => setOpen(true)}>
        <LuShieldMinus />
        Tornar membro
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          title="Tornar membro"
          body={<>Tem certeza que deseja remover as permissões de admin de <strong>{member.user.name}</strong>?</>}
          onConfirm={handleConfirm}
          confirmColorPalette="gray"
          isPending={isPending}
        />
      )}
    </>
  )
}

export default DemoteMemberButton
